
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.242","height":"26.185","viewBox":"0 0 23.242 26.185"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.588 4.24a2.129 2.129 0 002.138-2.12 2.134 2.134 0 00-4.268 0 2.109 2.109 0 002.13 2.12zm-2.8 20.417c0 .66.214 1.4.874 1.4s.986-.567.986-1.218v-9.963h1.86v9.985a1.081 1.081 0 001.078 1.171c.66 0 .781-.539.781-1.19V7.438H9.3l-.04 6.545a.948.948 0 101.9-.019V12.8l1.67-5.362h.948l-2.593 10.227h2.761v7.382c0 1.311 1.859 1.6 1.859.279v-7.661h.93v7.391c0 1.3 1.859 1.534 1.859.242v-7.633h3.012l-2.89-10.227h.995l1.729 5.5c.4 1.246 2.129.93 1.748-.353l-1.916-6.049a3.336 3.336 0 00-2.919-1.887h-4.4a2.87 2.87 0 00-2.687 1.887L11.129 7A2.766 2.766 0 008.4 4.649H2.724A2.74 2.74 0 000 7.4v6.564a.93.93 0 101.859 0V7.438h.93zM16.27 4.249a2.181 2.181 0 002.23-2.12 2.234 2.234 0 00-4.463 0 2.175 2.175 0 002.233 2.12z","fill":"#fff","fill-rule":"evenodd"}})])
          )
        }
      }
    